import Guard from 'arg-guard'

import Service from './service'
import ServiceOperation from './service-operation'
import Logger from '../logger'

/**
 * Gateway for accessing the contact service.
 *
 * @export ContactService
 * @class ContactService
 */
export default class ContactService extends Service {

    /**
     * Creates an instance of ContactService.
     * @memberof ContactService
     */
    constructor() {
        super('/contact', 'Contact')
    }

    /**
     * Makes a request for contact.
     *
     * @param {number} schemeId
     * @param {AppError} error
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof ContactService
     */
    async reportErrorAsync(schemeId, error) {
        Guard.throwIf(error, 'error')

        const operationState = new ServiceOperation('Report Error', true)
        const url = `report-error`
        const data = {
            schemeId,
            errorMessage: error.message,
            state: JSON.stringify(error.state, null, 2),
        }

        Logger.logObject(data, `${ this.baseUrl }/${ url }`, 'Request [POST]')

        try {
            return this._processResponse(await this.axios.post(url, data, this._buildAxiosConfig()), operationState, 'reportErrorAsync')
        } catch (err) {
            return this._failOperation(err, operationState, 'reportErrorAsync')
        }
    }

    /**
     * Makes a request for contact.
     *
     * @param {number} schemeId
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof ContactService
     */
    async requestContactAsync(schemeId) {
        const operationState = new ServiceOperation('Request Contact', true)
        const url = `request`
        const data = {
            schemeId,
        }

        Logger.logObject(data, `${ this.baseUrl }/${ url }`, 'Request [POST]')

        try {
            return this._processResponse(await this.axios.post(url, data, this._buildAxiosConfig()), operationState, 'requestContactAsync')
        } catch (err) {
            return this._failOperation(err, operationState, 'requestContactAsync')
        }
    }

    /**
     * Sets the contact status to 'Contact Made'.
     *
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof ContactService
     */
    async setContactMadeAsync() {
        const operationState = new ServiceOperation('Set Contact Made', true)
        const url = `status/2`

        Logger.log(`${ this.baseUrl }/${ url }`, 'Request [PUT]')

        try {
            return this._processResponse(await this.axios.put(url, {}, this._buildAxiosConfig()), operationState, 'setContactMadeAsync')
        } catch (err) {
            return this._failOperation(err, operationState, 'setContactMadeAsync')
        }
    }
}
